var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "rbv-dropdown",
    {
      class: _vm.$style.sorter,
      attrs: {
        "is-open": _vm.isOpen,
        "backdrop-style": "transparent",
        align: "right",
      },
      on: { close: _vm.toggle },
    },
    [
      _c(
        "div",
        {
          class: _vm.$style.togglerContainer,
          attrs: { slot: "toggler" },
          slot: "toggler",
        },
        [
          _c(
            "button",
            {
              staticClass: "rbButton",
              class: _vm.styleSize.toggler,
              on: { click: _vm.toggle },
            },
            [
              _c("span", { class: _vm.$style.togglerText }, [
                _vm._v(_vm._s(_vm.toggleText)),
              ]),
              _c(
                "i",
                {
                  staticClass: "material-icons",
                  class: _vm.sorter.order !== "desc" && _vm.styleSize.sortAsc,
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.invertSort.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("sort")]
              ),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          class: _vm.$style.dropdownContainer,
          attrs: { slot: "dropdown" },
          on: { click: _vm.toggle },
          slot: "dropdown",
        },
        _vm._l(_vm.sorts, function (field) {
          return _c(
            "button",
            {
              key: field.id,
              staticClass: "rbButtonMenuItem",
              on: {
                click: function ($event) {
                  return _vm.onDestinationSortChanged(field.id)
                },
              },
            },
            [_vm._v(" " + _vm._s(field.text) + " ")]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }